// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"loading_loading-wrapper_tCaGm","loading-main-wrapper":"loading_loading-main-wrapper_aEO2N","loading-land-wrapper":"loading_loading-land-wrapper_VNM2w"};